module.exports = __webpack_public_path__ + "img/Avatar-13.6a14aa77.svg";